/**
 * Point-of-use AI-processing notice shown wherever a user submits a
 * requirement description or supporting documents for AI analysis.
 * Defined once here and imported by every such surface so the copy
 * (and its link to /about) can't drift between them.
 */
import { Link } from 'react-router-dom';

export const AiProcessingNotice = ({ className = '' }) => (
  <p className={`text-xs text-zinc-500 leading-relaxed${className ? ` ${className}` : ''}`}>
    ProcMatrix uses AI to analyze your procurement requirements and
    supporting documents in order to generate procurement outputs.{' '}
    <Link to="/about" className="underline">See About</Link> for details.
  </p>
);
